import { computed, ref } from '@vue/composition-api';
import useList from '../_basic/list';
import useItem from '../_basic/item';
import gqlList from './list.graphql';
import gqlItem from './item.graphql';
import provider from '@/api/apollo-client';

export default function(filters) {
  const notifications = new useList(gqlList, filters);
  const notification = new useItem(gqlItem);
  const showFields = ref([
    'objectName',
    'tags',
    'byName',
    'message',
    'createdAt'
  ]);

  return {
    notification: {
      ...notification,
      sendNotification: data => {
        return provider.mutate({
          mutation: gqlItem.sendNotification,
          variables: {
            input: data
          }
        });
      },
      getNotificationDeliveries: data => {
        return provider.query({
          query: gqlItem.notificationDeliveriesConnection,
          variables: {
            ...data
          }
        });
      }
    },
    notifications: {
      ...notifications,
      subscribeNotifications: data => {
        return provider.subscribe({
          variables: {
            topic: data
          },
          query: gqlItem.subscribeNotifications
        });
      },
      visibleFields: computed({
        get: () => {
          const sorted = showFields.value.map(i => {
            return notifications.visibleFields.value.find(e => e === i);
          });
          if (notifications.visibleFields.value.length) {
            return sorted;
          }
          return [];
        },
        set: arr => {
          showFields.value = arr;
          notifications.visibleFields.value = arr;
        }
      }),
      fields: computed(() => {
        const sorted = showFields.value.map(i => {
          return notifications.fields.value.find(e => e.key === i);
        });
        if (notifications.fields.value.length) {
          return sorted;
        }
        return [];
      })
    }
  };
}
